export interface Country {
  id: string;
  name: string;
  flagEmoji: string;
  currency: string;
}

export const CountriesWithCurrencies: Country[] = [
  {id: 'AD', name: 'Andorra', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'AE', name: 'United Arab Emirates', flagEmoji: '🇦🇪', currency: 'AED'},
  {id: 'AF', name: 'Afghanistan', flagEmoji: '🇦🇫', currency: 'AFN'},
  {id: 'AG', name: 'Antigua and Barbuda', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'AI', name: 'Anguilla', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'AL', name: 'Albania', flagEmoji: '🇦🇱', currency: 'ALL'},
  {id: 'AM', name: 'Armenia', flagEmoji: '🇦🇲', currency: 'AMD'},
  {id: 'AO', name: 'Angola', flagEmoji: '🇦🇴', currency: 'AOA'},
  {id: 'AQ', name: 'Antarctica', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'AR', name: 'Argentina', flagEmoji: '🇦🇷', currency: 'ARS'},
  {id: 'AS', name: 'American Samoa', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'AT', name: 'Austria', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'AU', name: 'Australia', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'AW', name: 'Aruba', flagEmoji: '🇦🇼', currency: 'AWG'},
  {id: 'AX', name: 'Åland', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'AZ', name: 'Azerbaijan', flagEmoji: '🇦🇿', currency: 'AZN'},
  {id: 'BA', name: 'Bosnia and Herzegovina', flagEmoji: '🇧🇦', currency: 'BAM'},
  {id: 'BB', name: 'Barbados', flagEmoji: '🇧🇧', currency: 'BBD'},
  {id: 'BD', name: 'Bangladesh', flagEmoji: '🇧🇩', currency: 'BDT'},
  {id: 'BE', name: 'Belgium', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'BF', name: 'Burkina Faso', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'BG', name: 'Bulgaria', flagEmoji: '🇧🇬', currency: 'BGN'},
  {id: 'BH', name: 'Bahrain', flagEmoji: '🇧🇭', currency: 'BHD'},
  {id: 'BI', name: 'Burundi', flagEmoji: '🇧🇮', currency: 'BIF'},
  {id: 'BJ', name: 'Benin', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'BL', name: 'Saint Barthélemy', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'BM', name: 'Bermuda', flagEmoji: '🇧🇲', currency: 'BMD'},
  {id: 'BN', name: 'Brunei', flagEmoji: '🇧🇳', currency: 'BND'},
  {id: 'BO', name: 'Bolivia', flagEmoji: '🇧🇴', currency: 'BOB'},
  {id: 'BQ', name: 'Bonaire', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'BR', name: 'Brazil', flagEmoji: '🇧🇷', currency: 'BRL'},
  {id: 'BS', name: 'Bahamas', flagEmoji: '🇧🇸', currency: 'BSD'},
  {id: 'BT', name: 'Bhutan', flagEmoji: '🇧🇹', currency: 'BTN'},
  {id: 'BV', name: 'Bouvet Island', flagEmoji: '🇧🇻', currency: 'NOK'},
  {id: 'BW', name: 'Botswana', flagEmoji: '🇧🇼', currency: 'BWP'},
  {id: 'BY', name: 'Belarus', flagEmoji: '🇧🇾', currency: 'BYN'},
  {id: 'BZ', name: 'Belize', flagEmoji: '🇧🇿', currency: 'BZD'},
  {id: 'CA', name: 'Canada', flagEmoji: '🇨🇦', currency: 'CAD'},
  {id: 'CC', name: 'Cocos [Keeling] Islands', flagEmoji: '🇦🇺', currency: 'AUD'},
  {
    id: 'CD',
    name: 'Democratic Republic of the Congo',

    flagEmoji: '🇨🇩',
    currency: 'CDF',
  },
  {id: 'CF', name: 'Central African Republic', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'CG', name: 'Republic of the Congo', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'CH', name: 'Switzerland', flagEmoji: '🇨🇭', currency: 'CHF'},
  {id: 'CI', name: 'Ivory Coast', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'CK', name: 'Cook Islands', flagEmoji: '🇨🇰', currency: 'NZD'},
  {id: 'CL', name: 'Chile', flagEmoji: '🇨🇱', currency: 'CLP'},
  {id: 'CM', name: 'Cameroon', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'CN', name: 'China', flagEmoji: '🇨🇳', currency: 'CNY'},
  {id: 'CO', name: 'Colombia', flagEmoji: '🇨🇴', currency: 'COP'},
  {id: 'CR', name: 'Costa Rica', flagEmoji: '🇨🇷', currency: 'CRC'},
  {id: 'CU', name: 'Cuba', flagEmoji: '🇨🇺', currency: 'CUP'},
  {id: 'CV', name: 'Cape Verde', flagEmoji: '🇨🇻', currency: 'CVE'},
  {id: 'CW', name: 'Curacao', flagEmoji: '🇺🇳', currency: 'ANG'},
  {id: 'CX', name: 'Christmas Island', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'CY', name: 'Cyprus', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'CZ', name: 'Czech Republic', flagEmoji: '🇨🇿', currency: 'CZK'},
  {id: 'DE', name: 'Germany', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'DJ', name: 'Djibouti', flagEmoji: '🇩🇯', currency: 'DJF'},
  {id: 'DK', name: 'Denmark', flagEmoji: '🇩🇰', currency: 'DKK'},
  {id: 'DM', name: 'Dominica', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'DO', name: 'Dominican Republic', flagEmoji: '🇩🇴', currency: 'DOP'},
  {id: 'DZ', name: 'Algeria', flagEmoji: '🇩🇿', currency: 'DZD'},
  {id: 'EC', name: 'Ecuador', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'EE', name: 'Estonia', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'EG', name: 'Egypt', flagEmoji: '🇪🇬', currency: 'EGP'},
  {id: 'EH', name: 'Western Sahara', flagEmoji: '🇲🇦', currency: 'MAD'},
  {id: 'ER', name: 'Eritrea', flagEmoji: '🇪🇷', currency: 'ERN'},
  {id: 'ES', name: 'Spain', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'ET', name: 'Ethiopia', flagEmoji: '🇪🇹', currency: 'ETB'},
  {id: 'FI', name: 'Finland', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'FJ', name: 'Fiji', flagEmoji: '🇫🇯', currency: 'FJD'},
  {id: 'FK', name: 'Falkland Islands', flagEmoji: '🇫🇰', currency: 'FKP'},
  {id: 'FM', name: 'Micronesia', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'FO', name: 'Faroe Islands', flagEmoji: '🇩🇰', currency: 'DKK'},
  {id: 'FR', name: 'France', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'GA', name: 'Gabon', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'GB', name: 'United Kingdom', flagEmoji: '🇬🇧', currency: 'GBP'},
  {id: 'GD', name: 'Grenada', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'GE', name: 'Georgia', flagEmoji: '🇬🇪', currency: 'GEL'},
  {id: 'GF', name: 'French Guiana', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'GG', name: 'Guernsey', flagEmoji: '🇬🇧', currency: 'GBP'},
  {id: 'GH', name: 'Ghana', flagEmoji: '🇬🇭', currency: 'GHS'},
  {id: 'GI', name: 'Gibraltar', flagEmoji: '🇬🇮', currency: 'GIP'},
  {id: 'GL', name: 'Greenland', flagEmoji: '🇩🇰', currency: 'DKK'},
  {id: 'GM', name: 'Gambia', flagEmoji: '🇬🇲', currency: 'GMD'},
  {id: 'GN', name: 'Guinea', flagEmoji: '🇬🇳', currency: 'GNF'},
  {id: 'GP', name: 'Guadeloupe', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'GQ', name: 'Equatorial Guinea', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'GR', name: 'Greece', flagEmoji: '🇪🇺', currency: 'EUR'},
  {
    id: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    flagEmoji: '🇬🇧',
    currency: 'GBP',
  },
  {id: 'GT', name: 'Guatemala', flagEmoji: '🇬🇹', currency: 'GTQ'},
  {id: 'GU', name: 'Guam', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'GW', name: 'Guinea-Bissau', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'GY', name: 'Guyana', flagEmoji: '🇬🇾', currency: 'GYD'},
  {id: 'HK', name: 'Hong Kong', flagEmoji: '🇭🇰', currency: 'HKD'},
  {id: 'HM', name: 'Heard Island and McDonald Islands', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'HN', name: 'Honduras', flagEmoji: '🇭🇳', currency: 'HNL'},
  {id: 'HR', name: 'Croatia', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'HT', name: 'Haiti', flagEmoji: '🇭🇹', currency: 'HTG'},
  {id: 'HU', name: 'Hungary', flagEmoji: '🇭🇺', currency: 'HUF'},
  {id: 'ID', name: 'Indonesia', flagEmoji: '🇮🇩', currency: 'IDR'},
  {id: 'IE', name: 'Ireland', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'IL', name: 'Israel', flagEmoji: '🇮🇱', currency: 'ILS'},
  {id: 'IM', name: 'Isle of Man', flagEmoji: '🇬🇧', currency: 'GBP'},
  {id: 'IN', name: 'India', flagEmoji: '🇮🇳', currency: 'INR'},
  {
    id: 'IO',
    name: 'British Indian Ocean Territory',
    flagEmoji: '🇺🇸',
    currency: 'USD',
  },
  {id: 'IQ', name: 'Iraq', flagEmoji: '🇮🇶', currency: 'IQD'},
  {id: 'IR', name: 'Iran', flagEmoji: '🇮🇷', currency: 'IRR'},
  {id: 'IS', name: 'Iceland', flagEmoji: '🇮🇸', currency: 'ISK'},
  {id: 'IT', name: 'Italy', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'JE', name: 'Jersey', flagEmoji: '🇬🇧', currency: 'GBP'},
  {id: 'JM', name: 'Jamaica', flagEmoji: '🇯🇲', currency: 'JMD'},
  {id: 'JO', name: 'Jordan', flagEmoji: '🇯🇴', currency: 'JOD'},
  {id: 'JP', name: 'Japan', flagEmoji: '🇯🇵', currency: 'JPY'},
  {id: 'KE', name: 'Kenya', flagEmoji: '🇰🇪', currency: 'KES'},
  {id: 'KG', name: 'Kyrgyzstan', flagEmoji: '🇰🇬', currency: 'KGS'},
  {id: 'KH', name: 'Cambodia', flagEmoji: '🇰🇭', currency: 'KHR'},
  {id: 'KI', name: 'Kiribati', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'KM', name: 'Comoros', flagEmoji: '🇰🇲', currency: 'KMF'},
  {id: 'KN', name: 'Saint Kitts and Nevis', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'KP', name: 'North Korea', flagEmoji: '🇰🇵', currency: 'KPW'},
  {id: 'KR', name: 'South Korea', flagEmoji: '🇰🇷', currency: 'KRW'},
  {id: 'KW', name: 'Kuwait', flagEmoji: '🇰🇼', currency: 'KWD'},
  {id: 'KY', name: 'Cayman Islands', flagEmoji: '🇰🇾', currency: 'KYD'},
  {id: 'KZ', name: 'Kazakhstan', flagEmoji: '🇰🇿', currency: 'KZT'},
  {id: 'LA', name: 'Laos', flagEmoji: '🇱🇦', currency: 'LAK'},
  {id: 'LB', name: 'Lebanon', flagEmoji: '🇱🇧', currency: 'LBP'},
  {id: 'LC', name: 'Saint Lucia', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'LI', name: 'Liechtenstein', flagEmoji: '🇨🇭', currency: 'CHF'},
  {id: 'LK', name: 'Sri Lanka', flagEmoji: '🇱🇰', currency: 'LKR'},
  {id: 'LR', name: 'Liberia', flagEmoji: '🇱🇷', currency: 'LRD'},
  {id: 'LS', name: 'Lesotho', flagEmoji: '🇱🇸', currency: 'LSL'},
  {id: 'LT', name: 'Lithuania', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'LU', name: 'Luxembourg', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'LV', name: 'Latvia', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'LY', name: 'Libya', flagEmoji: '🇱🇾', currency: 'LYD'},
  {id: 'MA', name: 'Morocco', flagEmoji: '🇲🇦', currency: 'MAD'},
  {id: 'MC', name: 'Monaco', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'MD', name: 'Moldova', flagEmoji: '🇲🇩', currency: 'MDL'},
  {id: 'ME', name: 'Montenegro', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'MF', name: 'Saint Martin', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'MG', name: 'Madagascar', flagEmoji: '🇲🇬', currency: 'MGA'},
  {id: 'MH', name: 'Marshall Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'MK', name: 'North Macedonia', flagEmoji: '🇲🇰', currency: 'MKD'},
  {id: 'ML', name: 'Mali', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'MM', name: 'Myanmar [Burma]', flagEmoji: '🇲🇲', currency: 'MMK'},
  {id: 'MN', name: 'Mongolia', flagEmoji: '🇲🇳', currency: 'MNT'},
  {id: 'MO', name: 'Macao', flagEmoji: '🇲🇴', currency: 'MOP'},
  {id: 'MP', name: 'Northern Mariana Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'MQ', name: 'Martinique', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'MR', name: 'Mauritania', flagEmoji: '🇲🇷', currency: 'MRU'},
  {id: 'MS', name: 'Montserrat', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'MT', name: 'Malta', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'MU', name: 'Mauritius', flagEmoji: '🇲🇺', currency: 'MUR'},
  {id: 'MV', name: 'Maldives', flagEmoji: '🇲🇻', currency: 'MVR'},
  {id: 'MW', name: 'Malawi', flagEmoji: '🇲🇼', currency: 'MWK'},
  {id: 'MX', name: 'Mexico', flagEmoji: '🇲🇽', currency: 'MXN'},
  {id: 'MY', name: 'Malaysia', flagEmoji: '🇲🇾', currency: 'MYR'},
  {id: 'MZ', name: 'Mozambique', flagEmoji: '🇲🇿', currency: 'MZN'},
  {id: 'NA', name: 'Namibia', flagEmoji: '🇳🇦', currency: 'NAD'},
  {id: 'NC', name: 'New Caledonia', flagEmoji: '🇺🇳', currency: 'XPF'},
  {id: 'NE', name: 'Niger', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'NF', name: 'Norfolk Island', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'NG', name: 'Nigeria', flagEmoji: '🇳🇬', currency: 'NGN'},
  {id: 'NI', name: 'Nicaragua', flagEmoji: '🇳🇮', currency: 'NIO'},
  {id: 'NL', name: 'Netherlands', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'NO', name: 'Norway', flagEmoji: '🇳🇴', currency: 'NOK'},
  {id: 'NP', name: 'Nepal', flagEmoji: '🇳🇵', currency: 'NPR'},
  {id: 'NR', name: 'Nauru', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'NU', name: 'Niue', flagEmoji: '🇳🇿', currency: 'NZD'},
  {id: 'NZ', name: 'New Zealand', flagEmoji: '🇳🇿', currency: 'NZD'},
  {id: 'OM', name: 'Oman', flagEmoji: '🇴🇲', currency: 'OMR'},
  {id: 'PA', name: 'Panama', flagEmoji: '🇵🇦', currency: 'PAB'},
  {id: 'PE', name: 'Peru', flagEmoji: '🇵🇪', currency: 'PEN'},
  {id: 'PF', name: 'French Polynesia', flagEmoji: '🇺🇳', currency: 'XPF'},
  {id: 'PG', name: 'Papua New Guinea', flagEmoji: '🇵🇬', currency: 'PGK'},
  {id: 'PH', name: 'Philippines', flagEmoji: '🇵🇭', currency: 'PHP'},
  {id: 'PK', name: 'Pakistan', flagEmoji: '🇵🇰', currency: 'PKR'},
  {id: 'PL', name: 'Poland', flagEmoji: '🇵🇱', currency: 'PLN'},
  {id: 'PM', name: 'Saint Pierre and Miquelon', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'PN', name: 'Pitcairn Islands', flagEmoji: '🇵🇳', currency: 'NZD'},
  {id: 'PR', name: 'Puerto Rico', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'PS', name: 'Palestine', flagEmoji: '🇮🇱', currency: 'ILS'},
  {id: 'PT', name: 'Portugal', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'PW', name: 'Palau', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'PY', name: 'Paraguay', flagEmoji: '🇵🇾', currency: 'PYG'},
  {id: 'QA', name: 'Qatar', flagEmoji: '🇶🇦', currency: 'QAR'},
  {id: 'RE', name: 'Réunion', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'RO', name: 'Romania', flagEmoji: '🇷🇴', currency: 'RON'},
  {id: 'RS', name: 'Serbia', flagEmoji: '🇷🇸', currency: 'RSD'},
  {id: 'RU', name: 'Russia', flagEmoji: '🇷🇺', currency: 'RUB'},
  {id: 'RW', name: 'Rwanda', flagEmoji: '🇷🇼', currency: 'RWF'},
  {id: 'SA', name: 'Saudi Arabia', flagEmoji: '🇸🇦', currency: 'SAR'},
  {id: 'SB', name: 'Solomon Islands', flagEmoji: '🇸🇧', currency: 'SBD'},
  {id: 'SC', name: 'Seychelles', flagEmoji: '🇸🇨', currency: 'SCR'},
  {id: 'SD', name: 'Sudan', flagEmoji: '🇸🇩', currency: 'SDG'},
  {id: 'SE', name: 'Sweden', flagEmoji: '🇸🇪', currency: 'SEK'},
  {id: 'SG', name: 'Singapore', flagEmoji: '🇸🇬', currency: 'SGD'},
  {id: 'SH', name: 'Saint Helena', flagEmoji: '🇸🇭', currency: 'SHP'},
  {id: 'SI', name: 'Slovenia', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'SJ', name: 'Svalbard and Jan Mayen', flagEmoji: '🇳🇴', currency: 'NOK'},
  {id: 'SK', name: 'Slovakia', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'SL', name: 'Sierra Leone', flagEmoji: '🇸🇱', currency: 'SLE'},
  {id: 'SM', name: 'San Marino', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'SN', name: 'Senegal', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'SO', name: 'Somalia', flagEmoji: '🇸🇴', currency: 'SOS'},
  {id: 'SR', name: 'Suriname', flagEmoji: '🇸🇷', currency: 'SRD'},
  {id: 'SS', name: 'South Sudan', flagEmoji: '🇸🇸', currency: 'SSP'},
  {id: 'ST', name: 'São Tomé and Príncipe', flagEmoji: '🇸🇹', currency: 'STN'},
  {id: 'SV', name: 'El Salvador', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'SX', name: 'Sint Maarten', flagEmoji: '🇺🇳', currency: 'ANG'},
  {id: 'SY', name: 'Syria', flagEmoji: '🇸🇾', currency: 'SYP'},
  {id: 'SZ', name: 'Swaziland', flagEmoji: '🇸🇿', currency: 'SZL'},
  {id: 'TC', name: 'Turks and Caicos Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'TD', name: 'Chad', flagEmoji: '🇺🇳', currency: 'XAF'},
  {id: 'TF', name: 'French Southern Territories', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'TG', name: 'Togo', flagEmoji: '🇺🇳', currency: 'XOF'},
  {id: 'TH', name: 'Thailand', flagEmoji: '🇹🇭', currency: 'THB'},
  {id: 'TJ', name: 'Tajikistan', flagEmoji: '🇹🇯', currency: 'TJS'},
  {id: 'TK', name: 'Tokelau', flagEmoji: '🇳🇿', currency: 'NZD'},
  {id: 'TL', name: 'East Timor', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'TM', name: 'Turkmenistan', flagEmoji: '🇹🇲', currency: 'TMT'},
  {id: 'TN', name: 'Tunisia', flagEmoji: '🇹🇳', currency: 'TND'},
  {id: 'TO', name: 'Tonga', flagEmoji: '🇹🇴', currency: 'TOP'},
  {id: 'TR', name: 'Turkey', flagEmoji: '🇹🇷', currency: 'TRY'},
  {id: 'TT', name: 'Trinidad and Tobago', flagEmoji: '🇹🇹', currency: 'TTD'},
  {id: 'TV', name: 'Tuvalu', flagEmoji: '🇦🇺', currency: 'AUD'},
  {id: 'TW', name: 'Taiwan', flagEmoji: '🇹🇼', currency: 'TWD'},
  {id: 'TZ', name: 'Tanzania', flagEmoji: '🇹🇿', currency: 'TZS'},
  {id: 'UA', name: 'Ukraine', flagEmoji: '🇺🇦', currency: 'UAH'},
  {id: 'UG', name: 'Uganda', flagEmoji: '🇺🇬', currency: 'UGX'},
  {id: 'UM', name: 'U.S. Minor Outlying Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'US', name: 'United States', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'UY', name: 'Uruguay', flagEmoji: '🇺🇾', currency: 'UYU'},
  {id: 'UZ', name: 'Uzbekistan', flagEmoji: '🇺🇿', currency: 'UZS'},
  {id: 'VA', name: 'Vatican City', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'VC', name: 'Saint Vincent and the Grenadines', flagEmoji: '🇺🇳', currency: 'XCD'},
  {id: 'VE', name: 'Venezuela', flagEmoji: '🇻🇪', currency: 'VES'},
  {id: 'VG', name: 'British Virgin Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'VI', name: 'U.S. Virgin Islands', flagEmoji: '🇺🇸', currency: 'USD'},
  {id: 'VN', name: 'Vietnam', flagEmoji: '🇻🇳', currency: 'VND'},
  {id: 'VU', name: 'Vanuatu', flagEmoji: '🇻🇺', currency: 'VUV'},
  {id: 'WF', name: 'Wallis and Futuna', flagEmoji: '🇺🇳', currency: 'XPF'},
  {id: 'WS', name: 'Samoa', flagEmoji: '🇼🇸', currency: 'WST'},
  {id: 'XK', name: 'Kosovo', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'YE', name: 'Yemen', flagEmoji: '🇾🇪', currency: 'YER'},
  {id: 'YT', name: 'Mayotte', flagEmoji: '🇪🇺', currency: 'EUR'},
  {id: 'ZA', name: 'South Africa', flagEmoji: '🇿🇦', currency: 'ZAR'},
  {id: 'ZM', name: 'Zambia', flagEmoji: '🇿🇲', currency: 'ZMW'},
  {id: 'ZW', name: 'Zimbabwe', flagEmoji: '🇿🇼', currency: 'ZWL'},
];
